import { immerable } from "immer";
import type { ScheduleAlert } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlert.ts";
import type { ScheduleAlertLevel } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlertLevel.ts";
import { groupBy } from "@/shared/utils/Arrays.ts";

export class ScheduleAlerts {
  [immerable] = true;

  private readonly alerts: Map<ScheduleAlertLevel, ScheduleAlert[]>;

  public constructor(alerts: ScheduleAlert[] = []) {
    this.alerts = groupBy(alerts, (a) => a.level);
  }

  public isEmpty(): boolean {
    return this.alerts.size === 0;
  }

  public getBlockings(): ScheduleAlert[] {
    return this.getByLevel("BLOCKING");
  }

  public hasBlocking(): boolean {
    return this.getBlockings().length > 0;
  }

  public getWarnings(): ScheduleAlert[] {
    return this.getByLevel("WARNING");
  }

  private getByLevel(level: ScheduleAlertLevel): ScheduleAlert[] {
    return this.alerts.get(level) ?? [];
  }
}
